interface ShouldLoadPlmDeviceScheduleArgs {
  canAccessPlm: boolean;
  deviceId?: string | null;
  isPlmActive: boolean;
  isAbortDialogOpen: boolean;
  isScheduleDialogOpen: boolean;
}

export function shouldLoadPlmDeviceSchedule({
  canAccessPlm,
  deviceId,
  isPlmActive,
  isAbortDialogOpen,
  isScheduleDialogOpen,
}: ShouldLoadPlmDeviceScheduleArgs): boolean {
  return (
    canAccessPlm &&
    !!deviceId &&
    isPlmActive &&
    (isAbortDialogOpen || isScheduleDialogOpen)
  );
}
